<template>
  <div style="max-width: 100%;">
    
    <div id="snackbarid" @click="getAlert">
      <!--{{getAlert}}-->
    </div>
    
    <Navbar v-if="getAuthState"></Navbar>
    <!-- {{$store.getters.getCurrentPathProps}} -->
    <section style="padding-top: 20px;">
      <router-view></router-view>
    </section>  
    
    
    <b-modal :active.sync="$store.state.authInfo.authModal.show">
      <div style="background-color: white; overflow-y: auto">
        <PermissionAuth></PermissionAuth>
      </div>
    </b-modal>
    
    <b-modal :active.sync="getAlertBoxStatus">
      <div style="background-color: white; overflow-y: auto">
        <AlertBox></AlertBox>
      </div>
    </b-modal>
    
    <b-modal :can-cancel="false" :active.sync="$store.state.authInfo.confirmBox.show">
      <div style="background-color: white; overflow-y: auto">
        <ConfirmBox></ConfirmBox>
      </div>
    </b-modal>
    
    <div class="row">
      &nbsp;
    </div>
    <footer id="sticky">
      &copy; {{new Date().getFullYear()}} Frey Tax Law Firm
    </footer>


  </div>
</template>

<script>
import Navbar from './components/Navbar/Index.vue'
import Dashboard from './views/Dashboard/Index.vue'
import PermissionAuth from './views/Sessions/PermissionAuth/Index.vue';

export default {
  data () {
    return {
      routeInfo: []
    }
  },
  computed: {
    getAlertStatus() {
      return this.$store.state.authInfo.alert.show
    },
    getAlertBoxStatus() {
      return this.$store.state.authInfo.alertBox.show
    },
    getAuthState() {
      return this.$store.getters.isAuthenticated
    },
    getAlertMessage() {
      return this.$store.state.authInfo.alert.message
    }
  },
  components: {
    Navbar,
    Dashboard, PermissionAuth
  },
  methods: {
    getAlert() {
      this.$buefy.snackbar.open(this.getAlertMessage)
      setTimeout(() => {
        this.$store.state.authInfo.alert.show = false
      }, 3500);
    }, 
  },
  created() {
    if(this.getAuthState) {
      this.$store.dispatch('tryAutoLogin')      
    }
     
  },
  updated() {
    if(this.getAuthState) {
      this.$store.dispatch('tryAutoLogin')
    }
    
  }
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";

// Set your colors
$primary: #979090;
$primary-invert: findColorInvert($primary);
$twitter: #8b7d6b;
$twitter-invert: findColorInvert($twitter);

// Setup $colors to use as bulma classes (e.g. 'is-twitter')
$colors: (
    "white": ($white, $black),
    "black": ($black, $white),
    "light": ($light, $light-invert),
    "dark": ($dark, $dark-invert),
    "primary": ($primary, $primary-invert),
    "info": ($info, $info-invert),
    "success": ($success, $success-invert),
    "warning": ($warning, $warning-invert),
    "danger": ($danger, $danger-invert),
    "twitter": ($twitter, $twitter-invert)
);
// Links
$link: $twitter;
$link-invert: $primary-invert;
$link-focus-border: $primary;

// Import Bulma and Buefy styles
@import "~bulma";
@import "~buefy/src/scss/buefy";

body, a {
  font-size: 1em
}

.autocomplete {
  z-index: 1; position: absolute;
}

.draftInvoice {
    background-color: #FAFAD2;
}

.redRow {
    background-color: #ca445c;
    color: white;
}

.heading {
   font-size: 0.9em; 
}

.col-5 {
    float: left;
    width: 5%;
}

.col-10 {
    float: left;
    width: 10%;
}

.col-15 {
    float: left;
    width: 15%;
}

.col-20 {
    float: left;
    width: 20%;
}

.col-25 {
    float: left;
    width: 25%;
}
.col-30 {
    float: left;
    width: 30%;
}

.col-33 {
    float: left;
    width: 33%;
}

.col-35 {
    float: left;
    width: 35%;
}

.col-40 {
    float: left;
    width: 40%;
}

.col-45 {
    float: left;
    width: 45%;
}

.col-50 {
    float: left;
    width: 50%;
}


.col-60 {
    float: left;
    width: 60%;
}

.col-70 {
    float: left;
    width: 70%;
}

.col-75 {
    float: left;
    width: 75%;
}

.col-80 {
    float: left;
    width: 80%;
}

.col-85 {
    float: left;
    width: 85%;
}
.col-100 {
    float: left;
    width: 100%;
}

.no-scroll {
     overflow: visible !important;
}

/* Clear floats after the columns */
.row:after {
    content: "";
    display: table;
    clear: both;
    padding-top: 15px;

}

.rowBorder {
    border-color: #D8D8D8; 
    border-style: solid; 
    border-width: 1px; 
    padding-top: 10px;
    padding-right: 10px;
    padding-left: 10px;
    padding-bottom: 0px;
}

.border {
    border-color: #D8D8D8; 
    border-style: solid; 
    border-width: 1px; 
    padding: 5px;
    
}

.borderDashed {
    border-color: #eee; 
    border-style: dashed; 
    border-width: 1px; 
    padding: 15px;
    
}

.borderDashed1 {
    border-color: #eee; 
    border-style: dashed; 
    border-width: 1px; 
    padding: 2px;
    
}

.borderBottom {
    border-bottom-color: #D8D8D8; 
    border-bottom-style: dashed; 
    border-bottom-width: 1px; 
    padding: 5px;
    
}

.borderBottomSimple {
    border-bottom-color: #D8D8D8; 
    border-bottom-style: dashed; 
    border-bottom-width: 1px; 
    
}
.nativeinput {
  font-size: 0.85rem;
  font-weight: 400;
  height: 30px;
  width: 100%;
  padding: 5px;
  outline: #696969; 
  border-radius: 5px;
}

@media screen and (max-width: 700px) {
    .col-5, .col-10, .col-15, .col-25, .col-30, .col-20, .col-30, .col-35, .col-40, .col-45, .col-50, .col-60, .col-70, .col-75, .col-80, .col-85, .col-100 {
        width: 100%;
        margin-top: 0;
    }
    .autocomplete {
      z-index: 1;
      position: relative;
    }
}
label {
  font-size: 13px;
}
.label {
  font-size: 13px;
  font-weight: 100;
}
.bigLabel {
  font-size: 16px;
  font-weight: 100;
}
.binput {
  font-size: 0.85rem;
  font-weight: 400;
}
.shortLabel {
  font-size: 11px;
}

.DatePicker {
    width: 100%;
    padding: 5px;
    color: #000;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-sizing: border-box;
    resize: vertical;
    outline-color: #000;
    outline-width: 2px;
    font-size: inherit;
}
.hours-modal {
  overflow: visible;
  .modal-card-body {
    overflow: visible;
  }
}
.heading1 {
  font-size: 22px;
  font-weight: 500;
}

.heading2 {
  font-size: 18px;
  font-weight: 500;
}

.heading3 {
  font-size: 16px;
  font-weight: 500;
}

.horizontalBlock {
  width: 250px;
  height: 450px;
  max-height: 450px;
  display: inline-block;
  zoom: 1;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  margin-left: 5%;
  margin-bottom: 5%;
  padding: 10px;
  overflow-y: auto;
}

.horizontalBlockColored {
  background-color: #fdfd96;
  width: 250px;
  height: 450px;
  max-height: 450px;
  display: inline-block;
  zoom: 1;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  margin-left: 5%;
  margin-bottom: 5%;
  padding: 10px;
  overflow-y: auto;
}

#sticky {
  width:100%;
  padding:20px;
  padding-bottom:16px;
  color: #696969;
  font-size:12px;
  text-align:center;
  position:fixed;    /*Here's what sticks it*/
  bottom:0;          /*to the bottom of the body*/
  left:0;            /*and to the left of the body.*/
  
}
</style>



// WEBPACK FOOTER //
// src/App.vue